const config = {
  appName: 'COSEPAV',
  logoPath: '/assets/logo.svg', // ruta relativa desde public o src/assets
};

export default config;
